import { AnalysisExclusionsVic, AnalysisExclusionsQld } from "@/components/analysisExclusions";
import { useSearchParams } from "react-router-dom";

export function AnalysisExclusionsPage() {
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state")?.toLowerCase();

  switch (state) {
    case "qld":
      return <AnalysisExclusionsQld />;
    case "vic":
      return <AnalysisExclusionsVic />;
    default:
      // Default to Vic if not specified or unrecognized
      return <AnalysisExclusionsVic />;
  }
}

export default AnalysisExclusionsPage;
